import { Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSelection = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number, value: string) => {
    setAnchorEl(null);
    i18n.changeLanguage(value);
    window.localStorage.setItem('i18nextLng', value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const options = [
    { label: 'English', value: 'en' },
    { label: 'Deutsch', value: 'de' },
  ];

  return (
    <>
      <Typography style={{ cursor: 'pointer' }} variant="body1" sx={{ mr: 2 }} onClick={handleClickListItem}>
        {t('currentLanguage')}
      </Typography>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option, index) => (
          <MenuItem
            key={option.value}
            selected={option.value === t('currentLanguageCode')}
            onClick={(event) => handleMenuItemClick(event, index, option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
